import { ButtonProps } from '@mui/material'
import { ActionRequest, Project } from '../types'
import ProjectExtendButton from './ProjectExtendButton'
import { useEffect, useState } from 'react'
import { getProject } from '../services/projectService'

interface ActionRequestExtendProjectButtonProps extends Omit<ButtonProps, 'children'> {
  actionRequest: ActionRequest
  afterSubmit?: (actionRequest: ActionRequest) => void
}

export default function ActionRequestExtendProjectButton({
  actionRequest,
  afterSubmit,
  ...props
}: ActionRequestExtendProjectButtonProps) {
  /**
   * The project state.
   */
  const [project, setProject] = useState<Project>()

  /**
   * The loading state.
   */
  const [_loading, setLoading] = useState<boolean>(false)

  /**
   * The error state.
   */
  const [_error, setError] = useState<unknown>()

  /**
   * Load the project.
   */
  async function loadProject(id: number) {
    try {
      setLoading(true)
      setError(undefined)
      setProject(await getProject(id))
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  /**
   * Load the project when the action request is available.
   */
  useEffect(() => {
    if (actionRequest.requestableId) {
      loadProject(parseInt(actionRequest.requestableId))
    }
  }, [actionRequest.requestableId])

  if (project) {
    return (
      <ProjectExtendButton
        project={project}
        actionRequest={actionRequest}
        {...props}
        afterSubmit={afterSubmit}
      />
    )
  } else {
    return null
  }
}
